const api = '/api/v1/category.php';
import axios from 'axios';
export const categoryRepository =  {
    methods: {
        async GetCategories(){
            return  axios.get(api)
        }
    }
};

